<div class="xl:h-full w-full flex flex-col flex-grow p-5">
    <div class="mb-4">
        <h3 class="font-semibold m-0">
            <i class="fa-list-check fa-regular mr-1"></i>Your To-Do
        </h3>
    </div>
    <div
        class="flex flex-col xl:flex-row xl:flex-grow h-full w-full gap-5"
        rcpComLoadingOverlay
        [isLoading]="isLoading">
        <!-- TO-DOS-->
        <div class="w-full xl:w-2/3">
            <div
                *ngIf="!isLoading"
                class="flex flex-col h-full w-full rounded-lg bg-white border border-gray-border">
                <div
                    class="flex flex-row px-4 py-3 border-b border-gray-border">
                    <h4 class="m-0 font-semibold">To-Do</h4>
                </div>
                <div class="grow">
                    <rcp-oup-task-grid
                        [toDos]="toDos"
                        moduleView="GENERAL"
                        (tasksUpdated)="lookup()"
                        tableHeightClass="h-[400px] xl:h-full"></rcp-oup-task-grid>
                </div>
                <div class="px-4 py-3 border-t border-gray-border justify-end">
                    <rcp-com-button
                        [buttonStyle]="ButtonStyle.Tertiary"
                        label="View All"
                        routerLink="/os-worklist/to-do">
                    </rcp-com-button>
                </div>
            </div>
        </div>

        <!-- NOTIFICATIONS-->
        <div class="w-full xl:w-1/3">
            <div
                *ngIf="!isLoading"
                class="flex flex-col h-full w-full rounded-lg bg-white border border-gray-border">
                <div
                    class="flex flex-row justify-between items-center px-4 py-3">
                    <h4 class="m-0 font-semibold">Notifications</h4>
                    <div *ngIf="allOpenNotifications">
                        <span class="font-semibold text-sm"> Total Open: </span>
                        <span class="text-sm">{{
                            allOpenNotifications.value?.length
                        }}</span>
                    </div>
                </div>
                <div class="grow">
                    <rcp-oup-user-notifications-grid
                        [notifications]="allOpenNotifications"
                        [includePagination]="false"
                        moduleView="GENERAL"
                        tableHeightClass="h-[400px] xl:h-full"
                        [useDefaultNoResult]="true"
                        [useCondensedView]="true"
                        (notificationsUpdated)="lookup()">
                    </rcp-oup-user-notifications-grid>
                </div>
                <div class="px-4 py-3 border-t border-gray-border justify-end">
                    <rcp-com-button
                        [buttonStyle]="ButtonStyle.Tertiary"
                        label="View All"
                        routerLink="/os-worklist/notifications/open/3">
                    </rcp-com-button>
                </div>
            </div>
            <!-- Later we will likely replace this with a new component.-->
            <!-- ISSUES-->
            <!--<div
                *ngIf="!isLoading"
                class="w-1/2 bg-white border border-gray-border flex flex-col justify-center items-center max-h-[238px]">
                <div
                    class="w-full font-bold border-b border-gray-border bg-table-header-bg p-1.5">
                    <i class="fa-solid fa-triangle-exclamation pl-2"></i>
                    Issues
                </div>
                <div
                    class="flex flex-row w-full space-x-4 border-b border-gray-border bg-table-header-bg text-sm font-semibold items-center">
                    <span class="pl-4"
                        ><mat-icon class="pt-1">more_horiz</mat-icon></span
                    >
                    <span>Due</span>
                    <span>Severity</span>
                    <span>Description</span>
                </div>
                <div
                    class="flex flex-col justify-center items-center flex-grow max-w-[480px] pb-4">
                    <div
                        class="flex flex-row items-center text-[20px] font-serif italic font-semibold p-4">
                        <i
                            class="fa-regular fa-3x fa-megaphone text-main-red pr-3"></i>
                        <span>Coming Soon!</span>
                    </div>
                    <div class="text-center">
                        The ability to create, view, and manage issues to help
                        you efficiently manage insurance related processes in
                        your practice.
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</div>
